import { useQuery } from 'react-query';
import ProjectsAPI from 'services/API/ProjectsAPI';
import type { Project } from 'types';

type Props = {
  slugs: string[];
};

export const useProjectTitles = ({ slugs }: Props) => {
  const projects = useQuery(
    ['projectTitles', slugs],
    async (): Promise<Project[]> => {
      if (!slugs) {
        return [];
      }
      const result = await ProjectsAPI.getProjectTitles(slugs);

      return result?.data;
    },
    {
      refetchOnWindowFocus: false,
    },
  );

  return {
    projects,
  };
};
